import { Model } from '../../api/model';
import { ApiService } from '../../api/api.service';

export class PermissionModel extends Model {

    public id;

    public name;

    public display_name;

    public description;

    public checked: boolean;

    public constructor(data: Object = {}, _service?: ApiService) {
        super(data, _service);
        this.boot(data);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/authentication/models/permission.model.ts